/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { TERMINE_UPDATE_TERMIN } from '@/domain/termine/hooks/graphql/mutation';
import {
  TerminWiederholung,
  toGraphQLMarkierung,
  terminWiederholungToGraphQLMap,
  terminWiederholungsIntervallToGraphQLMap,
  terminWochentageToGraphQLMap,
  terminWeekdayOccurrenceToGraphQLMap,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { UpdateFormValueInput } from '@/domain/termine/shared/types/UpdateFormValueInput';
import {
  Termine_TerminUpdateInput,
  UpdateTerminMutation,
  UpdateTerminMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

export function useUpdateTermin() {
  const [mutate, { data, loading, error }] = useMutation<
    UpdateTerminMutation,
    UpdateTerminMutationVariables
  >(TERMINE_UPDATE_TERMIN, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    awaitRefetchQueries: true,
  });

  const updateTermin = async (termin: UpdateFormValueInput) => {
    let terminUpdate: Termine_TerminUpdateInput = {
      id: termin.id,
      datum: termin.datum,
      titel: termin.titel,
      beschreibung: termin.beschreibung,
      specials: termin.specials,
      markierung: toGraphQLMarkierung(termin.markierung),
      wiederholung:
        terminWiederholungToGraphQLMap[
          termin.wiederholung ?? TerminWiederholung.OHNE
        ],
      beginn: termin.beginn,
      ende: termin.ende,
      wiederholungBis: termin.wiederholungBis,
      individuelleWiederholung:
        termin.wiederholung === TerminWiederholung.INDIVIDUELL
          ? {
              occurrenceCount: termin.occurrenceCount ?? 1,
              wiederholungsIntervall:
                terminWiederholungsIntervallToGraphQLMap[
                  termin.wiederholungsIntervall
                    ? termin.wiederholungsIntervall
                    : TerminWiederholungsIntervall.WOCHE
                ],
              wochentage: termin.wochentagAuswahl
                ? termin?.wochentagAuswahl.map(
                    (day) => terminWochentageToGraphQLMap[day],
                  )
                : [],
              weekDayOccurrence: termin.wochentagAuftreten
                ? terminWeekdayOccurrenceToGraphQLMap[
                    termin?.wochentagAuftreten
                  ]
                : undefined,
            }
          : undefined,

      terminImage: termin.terminBildInput ?? undefined,
    };

    if (termin.terminKalenderId && termin.terminKalenderId !== 'NO_KALENDER') {
      terminUpdate = {
        ...terminUpdate,
        terminKalenderId: termin.terminKalenderId,
      };
    }
    try {
      const result = await mutate({
        variables: {
          termin: terminUpdate,
        },
      });

      if (result.data?.termine_terminUpdate.error) {
        throw new Error(result?.data.termine_terminUpdate.error.message);
      }
      return result.data?.termine_terminUpdate;
    } catch (error) {
      throw error instanceof Error ? error : new Error(String(error));
    }
  };

  return {
    updateTermin,
    response: data?.termine_terminUpdate,
    loading,
    error,
  };
}
